import { render, staticRenderFns } from "./ScrapModal.vue?vue&type=template&id=1603a599&scoped=true"
import script from "./ScrapModal.vue?vue&type=script&lang=js"
export * from "./ScrapModal.vue?vue&type=script&lang=js"
import style0 from "./ScrapModal.vue?vue&type=style&index=0&id=1603a599&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1603a599",
  null
  
)

export default component.exports